import { GBP } from './voucher.constants';
import { Currency, VoucherBasePrice } from './voucher.types';

export const calculatePrice = (
  basePriceData: VoucherBasePrice | undefined,
  months: number,
  subscriptions: number,
  currency: Currency | null,
): string => {
  const basePrice =
    basePriceData && currency && currency in basePriceData ? basePriceData[currency as keyof VoucherBasePrice] : 12;
  const symbol = currency === GBP ? '£' : '$';
  const price = (basePrice * months * subscriptions).toFixed(2);
  return `${symbol}${price}`;
};
